import { SplittingAction } from "./util.js";
import { Grid } from "../../core/components/grid.js";
import { Helper } from "../../core/util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import {
    ActionDataItem,
    Assignment,
    SplitAssignmentActions,
    SplittingDialogWrapperStaticData
} from "./splittingDialogTypes.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { Preview } from "./splittingPreview.js"
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";

export class SelectionGrid extends React.Component<SelectionGridProps, SelectionGridState> {
    private labelRef: HTMLAnchorElement;

    private gridOptions: kendo.ui.GridOptions;
    private gridId = kendo.guid();
    private dropDownBoxes: StringKeyDictionary<kendo.ui.DropDownList>;
    private actionInfoLabels: StringKeyDictionary<JQuery<HTMLElement>>;
    private suggestionIcons: StringKeyDictionary<JQuery<HTMLElement>>;

    constructor(props: SelectionGridProps) {
        super(props)

        this.state = {
            selected: null,
            showPreview: false,
            assignmentData: this.props.staticData.assignmentData,
            changedValues: []
        }
        this.init();
    }

    private init = () => {
        this.dropDownBoxes = {};
        this.actionInfoLabels = {};
        this.suggestionIcons = {};
        this.initGridOptions();
    }

    private initGridOptions = () => {
        this.gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Key",
                    title: Helper.getTranslation("BrowserTitle.Assigment.Available"),
                    width: 170,
                    template: (dataItem: { Key: string }) => {
                        const assignment = this.props.staticData.assignmentData[dataItem.Key].Assignment;
                        return `<a data-id=${dataItem.Key}>${assignment.ProjNo}/${assignment.Index}</a>`;
                    }
                },
                {
                    field: "Title",
                    width: 185,
                    title: Helper.getTranslation("Field.Einsatz.Bemerkung"),
                    template: (dataItem: KeyValuePair<string, SplittingAction>) => {
                        return `<div>${(this.props.staticData.assignmentData[dataItem.Key].Assignment.AssignmentTitle || "")}</div>`;
                    }
                },
                {
                    field: "Hinreise",
                    title: Helper.getTranslation("WebSMS.ServiceReport.Hinreise"),
                    width: 70,
                    template: (dataItem: KeyValuePair<string, SplittingAction>) => {
                        const assignment = this.props.staticData.assignmentData[dataItem.Key].Assignment;
                        const utilization = assignment.Utilization;
                        return `<div>${Helper.hasValue(utilization) ? Util.formatTime(utilization.Arrival || "") : ""}</div>`
                    }
                },
                {
                    field: "WorkingTime",
                    title: Helper.getTranslation("WebSMS.WeeklyReport.Arbeitszeit"),
                    width: 260,
                    template: (dataItem: KeyValuePair<string, SplittingAction>) => {
                        const assignment = this.props.staticData.assignmentData[dataItem.Key].Assignment;
                        const start = new Date(assignment.StartWork);
                        const end = new Date(assignment.EndWork);
                        const utilization = assignment.Utilization;
                        return Util.formatStartAndEnd(start, end, Helper.hasValue(utilization) ? Util.formatTime(utilization.Work || "") : "");
                    }
                },
                {
                    field: "Abreise",
                    title: Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Day.ReturnToHome"),
                    width: 70,
                    template: (dataItem: KeyValuePair<string, SplittingAction>) => {
                        const assignment = this.props.staticData.assignmentData[dataItem.Key].Assignment;
                        const utilization = assignment.Utilization;
                        return `<div>${Helper.hasValue(utilization) ? Util.formatTime(utilization.Departure || "") : ""}</div>`
                    }
                },
                {
                    field: "Value",
                    width: 260,
                    title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.Action"),
                    template: (dataItem: KeyValuePair<string, SplittingAction>) => {
                        if (dataItem.Key == this.props.staticData.splittingAssignment.IsGuid) {
                            return '<div style="display: flex;justify-content: center;align-items: center;"><i class="fa-light fa-scissors" style="height: 20px"></i></div>';
                        } else {
                            return `<div data-role="selectionGridActionWrapper" style="display: flex">
                                        <div style="width: 100%">
                                            <input class="dropDownTemplate"/>
                                            <label data-role="actionInfoLabel" style="line-height: 1.2em; font-size: 0.7em; padding: 1px 0 0 2px; color: #b71c1c; display: none">
                                                ${Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.NoExtendToRight")}
                                            </label>                    
                                        </div>
                                        <div data-role="suggestionIcon" style="grid-column: 2/3; grid-row: 1/3; justify-content: center;align-items: center; margin-left: 3px; display: none; width: 25px">
                                            <i class="fa-light fa-lightbulb-on"></i>
                                        </div>
                                </div>`;
                        }
                    }
                }

            ]
        };

        let tmp = 0;
        this.props.values.forEach((value) => {
            tmp += Util.getFixedInfoId(this.props.staticData.assignmentData[value.Key].Assignment);
        })
        if (tmp > 0) {
            this.gridOptions.columns.push({
                field: "FixedInfo",
                title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.Anomalies"),
                template: (dataItem: KeyValuePair<string, SplittingAction>) => {
                    const id = Util.getFixedInfoId(this.props.staticData.assignmentData[dataItem.Key].Assignment);
                    return `<div style="display: flex; flex-direction: column">
                                <label data-role="fixedInfoLabel">
                                    ${Util.fixedInfo()[id]}
                                </label>
                            </div>`;
                }
            })
        }
    }

    private renderGrid = () => {
        const values = [{
            Key: this.props.staticData.splittingAssignment.IsGuid,
            Value: null,
        }];

        return (
            <div className="flex-container" id={this.gridId} style={{ gridRow: "2/3", gridColumn: "1/2", width: "1200px" }}>
                <Grid
                    data={values.concat(this.props.values)}
                    options={this.gridOptions}
                    id="splitAssignments"
                    onDataBound={this.onDataBound}
                    onSelectionChanged={this.onSelectionChange}
                />
            </div>
        );
    }

    private onSelectionChange = (item: any) => {
        if (Helper.hasValue(item) && Helper.hasValue(this.props.markEvent)) {
            const id = `${this.props.staticData.assignmentData[item.Key].Assignment.ProjNo}|${this.props.staticData.assignmentData[item.Key].Assignment.Index}`
            this.props.markEvent(id);
            this.setState({ selected: item.Key })
        }
    }

    private getDataSource = (id: string) => {
        const allowedActions = Object.keys(this.state.assignmentData[id].AvailableActions);
        const filter = (item: { text: any, value: SplittingAction }) => {
            const index = allowedActions.findIndex(action => action == SplittingAction[item.value]);
            return index != -1;
        }
        return this.props.staticData.actions.filter(filter);
    }

    private onDataBound = (event: kendo.ui.GridDataBoundEvent) => {
        console.log("onDataBound")
        const data = event.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            const id: string = data[i].Key;
            const link = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] a`);
            link.on("click", () => {
                this.openSheet(id);
            });


            if (id === this.props.staticData.splittingAssignment.IsGuid) {
                const row = event.sender.tbody.find(`tr[data-uid='${data[i].uid}']`);
                const cell = $("td", row);
                cell.css("background-color", "#81d4fa");
                link.css("color", "#000000");
            }

            this.actionInfoLabels[id] = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] label[data-role='actionInfoLabel']`);
            this.suggestionIcons[id] = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] div[data-role='suggestionIcon']`);

            const input = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] .dropDownTemplate`);
            const value = data[i].Value;
            if (Helper.hasValue(value)) {
                let dataSource = this.getDataSource(id);
                // console.table(dataSource);
                const dropDown = Util.buildDropDown(input, id, value.toString(), dataSource, this.onChange);
                if (Helper.hasValue(dropDown)) {
                    this.dropDownBoxes[id] = dropDown;
                }
            }
        }
        this.updateActionInfoLableState();
        this.updateSuggestionIcons();
    }

    private onChange = async (id: string, action: SplittingAction) => {
        if (this.props.staticData.suggestionsActive) {
            let changedValues = this.state.changedValues;
            const index = changedValues.findIndex(val => val.AssignmentGuid == id);
            if (index === -1) {
                changedValues.push({
                    AssignmentGuid: id,
                    SelectedAction: action
                });
            } else {
                changedValues[index].SelectedAction = action;
            }
            changedValues = changedValues.filter((_, index) => {
                const i = this.props.values.findIndex(val => val.Key == id);
                return index <= i;
            })


            const result = await HTTPService.post<JsonResultClass<SplitAssignmentActions[]>>("SplitEvents/RecalculateRecommendations", {
                options: {
                    ProjNr: this.props.staticData.splittingAssignment.ProjNo,
                    PIndex: this.props.staticData.splittingAssignment.Index,
                    CuttingEdge: this.props.staticData.cuttingEdge,
                    Assignments: changedValues
                }
            });

            if (result.Code == 0) {
                const assignmentData: StringKeyDictionary<SplitAssignmentActions> = {};
                assignmentData[this.props.staticData.splittingAssignment.IsGuid] = {
                    Assignment: this.props.staticData.splittingAssignment,
                    AvailableActions: null,
                    DefaultAction: null,
                    Resource: this.props.staticData.resource
                };


                for (let i = 0; i < result.Data.length; i++) {
                    const data = result.Data[i];
                    assignmentData[data.Assignment.IsGuid] = {
                        Assignment: data.Assignment,
                        AvailableActions: data.AvailableActions,
                        DefaultAction: data.DefaultAction,
                        Resource: data.Resource
                    }
                }

                this.setState({ assignmentData: assignmentData, changedValues: changedValues }, () => {
                    this.props.onChangeAll(result.Data.map(item => { return { Key: item.Assignment.IsGuid, Value: item.DefaultAction } }))
                })
            }
        } else {
            this.props.onChange(id, action);
        }
    }


    private openSheet = (id: string) => {
        this.props.toggleDialog();
        const sheet = General.Sheet.Manager.createSheetWithUrl(`ResourcePlanning/EditByGuid?isguid=${id}` + "&readOnly=true");
        sheet.bind(SheetEventType.Close, () => {
            this.props.toggleDialog();
        })
    }

    componentDidUpdate() {
        this.updateActionInfoLableState();
        this.updateSuggestionIcons();
    }

    private updateActionInfoLableState = () => {
        const update = this.props.values.filter(val => val.Value == SplittingAction.ExtendToRight).length > 1;
        this.props.values.forEach((item) => {
            const display = update && item.Value == SplittingAction.ExtendToRight ? "block" : "none";
            this.actionInfoLabels[item.Key].css("display", display);
        })
    }

    private updateSuggestionIcons = () => {
        if (this.props.staticData.suggestionsActive && this.state.changedValues.length != 0) {
            this.props.values.forEach((value) => {
                const display = this.state.changedValues.findIndex(item => item.AssignmentGuid == value.Key) == -1 ? "flex" : "none";
                this.suggestionIcons[value.Key].css("display", display);
            })
        }
    }

    componentDidMount() {
        this.onPreviewLabelClick();
    }

    private renderPreview = () => {
        if (Helper.isNullOrEmpty(this.state.selected) || this.state.selected === this.props.staticData.splittingAssignment.IsGuid)
            return null;

        const data = this.state.assignmentData[this.state.selected];
        const value = this.props.values.find(val => val.Key == this.state.selected).Value;
        const key = Object.keys(data.AvailableActions).find((key) => {
            return value == SplittingAction[key]
        })
        let assignments = data.AvailableActions[key];
        if (!Helper.hasValue(assignments))
            assignments = [];
        // console.log(data, value, key, this.state);
        return (
            <>
                <Preview originalAssignment={data.Assignment} assignments={assignments} staticData={this.props.staticData} hash={Helper.getHashCode(`${this.state.selected}_${key}`)} />
            </>
        );
    }



    //kendo window überschreibt alle initalle onclick events...
    private onPreviewLabelClick = () => {

        this.labelRef.onclick = () => {
            this.setState({ showPreview: !this.state.showPreview })
        }
    }

    render() {
        return (
            <>
                <style>
                    {
                        `span.k-dropdown{
                            width: 100%;
                            grid-row: 1/2;
                            grid-column: 1/2;
                        }

                        .worktime_wrapper{
                            display: grid; 
                            grid-template-rows: 17px 0.25px 17px; 
                            grid-template-columns: 75px 75px 75px;
                        }

                        .worktime_wrapper div{
                            display: flex; 
                            justify-content: center; 
                            align-items: center;
                            font-size: 15px;
                        }

                        .worktime_wrapper__arrow{
                            grid-row: 2/3; 
                            grid-column: 2/3;
                            background-color: #666;
                            width: 90%;
                            position: relative;
                        }

                        .worktime_wrapper__arrow::after{
                            position: absolute;
                            top: -3px;
                            right: -1px;
                            border-top: 3.5px solid transparent;
                            border-bottom: 4.5px solid transparent;
                            border-left: 6.5px solid currentColor;
                            content: "";
                        }`
                    }
                </style>
                <div style={{ display: "grid", gridTemplateRows: "25px auto", gridTemplateColumns: "auto auto" }}>
                    <div style={{ gridRow: "1/2", gridColumn: "1/3", display: !Helper.isNullOrEmpty(this.state.selected) && this.state.selected != this.props.staticData.splittingAssignment.IsGuid ? "flex" : "none", flexDirection: "row-reverse" }} >
                        <a ref={(ref) => { this.labelRef = ref }} >{Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.ShowPreview")}</a>
                    </div>
                    {this.renderGrid()}
                    <div style={{ display: this.state.showPreview ? "block" : "none", gridRow: "2/3", gridColumn: "2/3" }}>
                        {this.renderPreview()}
                    </div>
                </div>
            </>
        );
    }
}

interface SelectionGridProps {
    values: KeyValuePair<string, SplittingAction>[];

    onChange: (id: string, action: SplittingAction) => void;
    onChangeAll: (data: KeyValuePair<string, SplittingAction>[]) => void;

    toggleDialog: () => void;
    markEvent?: (id: string) => void;

    staticData: SplittingDialogWrapperStaticData;
}

interface SelectionGridState {
    selected: string;
    showPreview: boolean;
    assignmentData: StringKeyDictionary<SplitAssignmentActions>;
    changedValues: {
        AssignmentGuid: string,
        SelectedAction: SplittingAction
    }[];
}


class Util {

    static formatTime = (value: string) => {
        const re = /^\d:\d\d:\d\d:\d\d$/ig;
        if (!re.test(value))
            return "";

        const arr = value.split(":");
        return `${arr[1]}:${arr[2]}`;

    }

    static buildDropDown = (element: JQuery<HTMLElement>, id: string, value: string, dataSource: ActionDataItem[], onChange: (id: string, action: SplittingAction) => void) => {
        if (Helper.hasValue(element[0])) {
            const dropDown = $(element).kendoDropDownList({
                value: value,
                dataSource: dataSource,
                dataTextField: "text",
                dataValueField: "value",
                change: (e) => {
                    const index = e.sender["selectedIndex"]
                    const ds = e.sender.dataSource.data();
                    onChange(id, ds[index].value);
                }
            }).data("kendoDropDownList");
            dropDown.list.width(350);
            return dropDown;
        }
        return null;
    }

    static getFixedInfoId = (assignment: Assignment) => {
        let result = 0;
        result += assignment.FixedStart ? 1 : 0;
        result += assignment.FixedEnd ? 2 : 0;
        result += assignment.FixedResource ? 4 : 0;
        return result;
    }

    static fixedInfo = () => {
        return {
            0: "",
            1: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.FixedInfo.Start"),
            2: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.FixedInfo.End"),
            3: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.FixedInfo.StartEnd"),
            4: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.FixedInfo.Res"),
            5: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.FixedInfo.StartRes"),
            6: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.FixedInfo.EndRes"),
            7: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.FixedInfo.All")
        };
    }

    static formatStartAndEnd = (start: Date, end: Date, workTime: string) => {
        const isSameDay = start.getFullYear() == end.getFullYear()
            && start.getMonth() == end.getMonth()
            && start.getDate() == end.getDate();

        return `
            <style>


            </style>
            <div class="worktime_wrapper">
                <div style="grid-row: 1/2; grid-column: 1/2;">
                    ${kendo.toString(start, "ddd dd.MMM")}
                </div>
                <div style="grid-row: 3/4; grid-column: 1/2;">
                    ${kendo.toString(start, "HH:mm")}
                </div>

                <div style="grid-row: 1/2; grid-column: 2/3;">${workTime}</div>
                <div class="worktime_wrapper__arrow"></div>

                <div style="grid-row: 1/2; grid-column: 3/4;">
                    ${isSameDay ? "" : kendo.toString(end, "ddd dd.MMM")}
                </div>

                <div style="grid-row: ${isSameDay ? "1/4" : "3/4"}; grid-column: 3/4;">
                    ${kendo.toString(end, "HH:mm")}
                </div>
            </div>
        `;

    }
}